import React, { useEffect, useState } from 'react';
import { Grid, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useSelector } from 'react-redux';
import { selectSubmissionPreferences } from '../../store/OrderPreference.selector';
import { useTranslation } from 'react-i18next';
import { ExistingPlacementGlance } from './ExistingPlacementGlance';
import { XGrid } from 'app/components/Common/XGrid/XGrid';
import { extractRows, getExistngRfoColumns } from './utils';

const useStyles = makeStyles()({
  confirmationText: { fontWeight: 450 },
});

export const ExistingRFOs = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();

  const { existingRFOs, readyToSubmitPlacementIds } = useSelector(selectSubmissionPreferences);

  const [rows, setRows] = useState<any[]>([]);
  const [sortModel] = React.useState<any>([
    {
      field: 'statusUpdatedDate',
      sort: 'asc',
    },
  ]);

  // eslint-disable-next-line prettier/prettier
  useEffect(
    () => setRows(extractRows(existingRFOs, readyToSubmitPlacementIds)),
    [existingRFOs, readyToSubmitPlacementIds],
  );

  return (
    <Grid container spacing={2} style={{ marginBottom: '-3px' }}>
      <Grid item xs={12}>
        <Typography variant="body1">
          {existingRFOs.length
            ? t('facility.unitPreference.existingPlacementsFoundMaxFile')
            : t('facility.unitPreference.existingPlacementsFoundMaxFile')}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography variant="body1" classes={{ body1: classes.confirmationText }}>
          {t('facility.unitPreference.existingPlacementsFoundconfirmText')}
        </Typography>
      </Grid>
      {existingRFOs.length ? (
        <Grid container item xs={12}>
          <ExistingPlacementGlance />
        </Grid>
      ) : null}
      {existingRFOs.length ? (
        <Grid item xs={12}>
          <XGrid
            rows={rows}
            columns={getExistngRfoColumns(t, readyToSubmitPlacementIds)}
            title={''}
            disableSelectionOnClick
            pagination={false}
            hideFooter
            autoHeight
            sortModel={sortModel}
            inDialog
          />
        </Grid>
      ) : null}
    </Grid>
  );
};
